import * as UI from "@iyk/ui"
import * as React from "react"

import { Analytics, useAnalytics } from "@iyk/vf-observability/react"
import { Sheet } from "./sheet.tsx"

export const HowToTapDialog = ({
  trigger,
  videoSrc,
  open,
  setOpen
}: {
  trigger?: React.ReactNode
  videoSrc: string
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const analytics = useAnalytics()

  const handleOpenChange = (open: boolean) => {
    if (open) analytics.track(Analytics.Event.HowToTapViewed())
    setOpen(open)
  }

  return (
    <Sheet.Root open={open} onOpenChange={handleOpenChange}>
      {trigger ? (
        <Sheet.Trigger asChild>{trigger}</Sheet.Trigger>
      ) : (
        <Sheet.Trigger className="relative flex items-center justify-between rounded border border-white/[10%] bg-white/[3%] p-3 overflow-hidden">
          <span className="uppercase font-departure-mono text-xs-departure text-left">
            How to tap your Portman Road
            <br />
            Commemorative Lanyard
          </span>
          <UI.Icon.Question />
        </Sheet.Trigger>
      )}
      <Sheet.Content
        title="How to tap your Portman Road Commemorative Lanyard"
        description="Tap the lanyard to unlock bonus content and access to 'Play'."
      >
        <div className="flex flex-col gap-6 px-4 py-8">
          <h3 className="text-xl">Claim to unlock rewards</h3>
          <video
            src={videoSrc}
            className="size-full aspect-video"
            preload="metadata"
            playsInline
            controls
            autoPlay
            muted={false}
          />
          <p className="text-sm">
            Tap your Portman Road Commemorative Lanyard to unlock bonus content and access to 'Play'.
          </p>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}
